(function (window, document) {
    'use strict';

    Foundation.libs.pcc = {
        name: "pcc",
        version: "1.0.0",
        init: function (scope, method, options) {
            // initialisation � conserver
            Foundation.inherit(this, 'throttle random_str');
            this.initPccs();

            this.bindings(method, options);
        },
        events: function () {   
            this.initPccs();
        },

        initPccs: () => {
            const pccs = document.querySelectorAll(".pcc-wrapper:not(.-initialized)");
            pccs.forEach(pcc => Foundation.libs.pcc.initPcc(pcc));
            //document.addEventListener("click", (e) => {
            //    console.log(e);d
            //})
        },

        initPcc: (pcc) => {
            const dropdownTrigger = pcc.querySelector(".pcc__selected-code");
            dropdownTrigger.addEventListener("click", () => Foundation.libs.pcc.handlePccClick(pcc));

            const closeButton = pcc.querySelector(".pcc__close");
            closeButton.addEventListener("click", () => Foundation.libs.pcc.handlePccClick(pcc));

            const searchBar = pcc.querySelector(".pcc__searchbar");
            searchBar.addEventListener("keyup", () => Foundation.libs.pcc.handlePccSearch(pcc, searchBar));

            const codes = pcc.querySelectorAll(".pcc__code");
            codes.forEach(code => code.addEventListener("click", () => Foundation.libs.pcc.handleCodeSelect(pcc, code)));

            const selectedCode = dropdownTrigger.getAttribute("data-value");
            const matchingCode = pcc.querySelector(".pcc__code[data-phoneCode='" + selectedCode + "']");
            matchingCode.classList.add("-selected");

            pcc.classList.add("-initialized");
        },

        handlePccClick: (pcc) => {
            const dropdown = pcc.querySelector(".pcc__dropdown");
            Foundation.libs.pcc.toggleDropdown(dropdown);
        },

        toggleDropdown: (dropdown) => {
            if (dropdown.classList.contains("-active")) {
                dropdown.classList.remove("-active");
                Foundation.libs.pcc.clearPccSearch(dropdown);
            } else {
                dropdown.classList.add("-active");
                const selectedCode = dropdown.querySelector(".pcc__code.-selected");
                const searchWrapper = dropdown.querySelector(".pcc__search");
                console.log(selectedCode);

                if (selectedCode) {
                    dropdown.scroll(0, (selectedCode.offsetTop - searchWrapper.offsetHeight));
                }

                const wrapper = dropdown.closest(".pcc-wrapper");
                Foundation.libs.pcc.handleOutslideClick(wrapper);
            }
        },

        handleOutslideClick: (pcc) => {
            const outsideClickListener = (e) => {
                const dropdown = pcc.querySelector(".pcc__dropdown");
                if (!pcc.contains(e.target) && dropdown.classList.contains("-active")) {
                    Foundation.libs.pcc.toggleDropdown(dropdown);
                    removeClickListener();
                }
            };

            const removeClickListener = () => {
                document.removeEventListener("click", outsideClickListener);
            }

            document.addEventListener("click", outsideClickListener);
        },

        handlePccSearch: (pcc, searchBar) => {
            const search = searchBar.value;
            const resultsList = pcc.querySelectorAll(".pcc__code");
            const resultsFiltered = Array.from(resultsList).filter(el => el.innerText.toLowerCase().includes(search.toLowerCase()));

            for (const code of resultsList) {

                const isCodeActive = resultsFiltered.findIndex(el => el.innerText == code.innerText) != -1;

                if (isCodeActive) {
                    if (code.classList.contains("-hidden")) {
                        code.classList.remove("-hidden");
                    }
                } else {
                    if (!code.classList.contains("-hidden")) {
                        code.classList.add("-hidden");
                    }
                }
            }
        },

        handleCodeSelect: (pcc, code) => {
            const selectedCode = pcc.querySelector(".pcc__selected-code");
            const hiddenFieldCountryCode = pcc.querySelector("input[data-id='input-client-phone-country-code']");
            const hiddenFieldPhoneCode = pcc.querySelector("input[data-id='input-client-phone-code']");
            const newPhoneCode = code.getAttribute("data-phoneCode");
            const newCountryCode = code.getAttribute("data-countryCode");
            const newAlpha2 = code.getAttribute("data-alpha2");
            const searchBar = pcc.querySelector(".pcc__searchbar");
            // Je mets au pluriel mais normalement il ne devrait pas y en avoir + qu'1
            const selectedCodes = pcc.querySelectorAll(".pcc__code.-selected");
            selectedCodes.forEach(code => code.classList.remove("-selected"));

            code.classList.add("-selected");

            selectedCode.value = newPhoneCode;
            selectedCode.innerHTML = `<i class="fflag fflag-${newAlpha2} ff-sm"></i>${newPhoneCode}<div class="arrow">C</div>`;
            selectedCode.setAttribute("data-value", newPhoneCode);
            hiddenFieldPhoneCode.value = newPhoneCode;

            hiddenFieldCountryCode.value = newCountryCode;

            Foundation.libs.pcc.handlePccClick(pcc);

            Foundation.libs.pcc.clearPccSearch(pcc);

            Foundation.libs.pcc.handlePccSearch(pcc, searchBar);
        },

        clearPccSearch: (wrapper) => {
            const searchbar = wrapper.querySelector(".pcc__searchbar");
            searchbar.value = "";
            Foundation.libs.pcc.handlePccSearch(wrapper, searchbar);
        }
    }
})(this, document);